module.exports = __webpack_public_path__ + "img/서브_모험심.a7985aec.svg";